import auth from '../../middlewares/auth';

export const leaveRequestRoutes = [
  {
    path: '/leave-requests',
    component: () =>
      import(
        /* webpackChunkName: "leave" */ '../../views/leave_requests/LeaveRequest'
      ),
    name: 'leave-requests',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/leave-request/:id',
    component: () =>
      import(
        /* webpackChunkName: "leave" */ '../../views/leave_requests/LeaveRequestForm'
      ),
    name: 'update-leave-request',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/create-leave-request',
    component: () =>
      import(
        /* webpackChunkName: "leave" */ '../../views/leave_requests/LeaveRequestForm'
      ),
    name: 'create-leave-request',
    meta: {
      middleware: [auth],
    },
  },
];
